import moment from "moment";

export function formatDateToHumanFirendly(dateStr: string): string {
  const [year, month, day] = dateStr.split("T")[0].split("-");

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const shortMonth = monthNames[parseInt(month, 10) - 1];
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const dayOfWeek = weekdays[new Date(`${year}-${month}-${day}`).getUTCDay()];

  const formattedDate = `${dayOfWeek}, ${shortMonth} ${parseInt(
    day,
    10
  )}, ${year}`;
  return formattedDate;

}

export function formatTimeToHumanFirendly24Hour(dateStr: string): string {
  const timePart = dateStr.split("T")[1].split("-")[0];
  const [hour, minute] = timePart.split(":").map(Number);

  // Return in 24-hour format: HH:mm
  return `${hour.toString().padStart(2, "0")}:${minute
    .toString()
    .padStart(2, "0")}`;
}

export function formatTimeToHumanFirendly12Hour(dateStr: string): string {
  const timePart = dateStr.split("T")[1].split("-")[0];

  const [hour, minute] = timePart.split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  const formattedHour = hour % 12 || 12;

  const formattedTime = `${formattedHour}:${minute
    .toString()
    .padStart(2, "0")} ${period}`;

  return formattedTime;
}


export function formatTimestamp(isoString: any) {
  // Create a Date object from the ISO string
  const dateObj = new Date(isoString);

  // Extract date (year, month, day) and create a new Date object
  const formattedDate = new Date(
    dateObj.getUTCFullYear(),
    dateObj.getUTCMonth(),
    dateObj.getUTCDate()
  );

  // Extract time components
  let hours = dateObj.getUTCHours();
  const minutes = String(dateObj.getUTCMinutes()).padStart(2, "0");

  // Determine AM or PM
  const period = hours >= 12 ? "PM" : "AM";

  // Convert 24-hour time to 12-hour format
  hours = hours % 12 || 12;

  // Return formatted values
  return {
    date: formattedDate, // Date object
    hours: hours.toString().padStart(2, "0"),
    minutes,
    period,
  };
}
export const validateTripDays = (
  startDate: null | Date,
  endDate: null | Date,
  selectedCar: any
): boolean => {
  if (!startDate || !endDate || !selectedCar) return false;

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Ensure valid date objects
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return false;

  const diffInDays = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);

  const minDays = selectedCar.min_trip_duration ?? 0; // Default to 0 if null/undefined
  const maxDays = selectedCar.max_trip_duration ?? Infinity; // Default to Infinity if null/undefined

  return diffInDays >= minDays && diffInDays <= maxDays;
};

 export const formatToISO = (date: Date) => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  const hour = `${date.getHours()}`.padStart(2, "0");
  const minute = `${date.getMinutes()}`.padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}:00`;
};

export const formatDateAndTimeToISO = (dateString: Date, timeString: string): string => {
  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = `${dateObj.getMonth() + 1}`.padStart(2, "0");
  const day = `${dateObj.getDate()}`.padStart(2, "0");
  const [hour, minute] = timeString.split(":").map(num => num.padStart(2, "0"));
  const timezoneMatch = dateString.toString().match(/GMT([+-]\d{2})(\d{2})/);
  let timezoneOffset = "+00:00";
  
  if (timezoneMatch) {
    const tzHour = timezoneMatch[1];
    const tzMin = timezoneMatch[2];
    timezoneOffset = `${tzHour}:${tzMin}`;
  }
  
  return `${year}-${month}-${day}T${hour}:${minute}:00`;
};
